import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fatal } from '@/utils'
import { IBCTransferStatus } from '@/wallet-utils'
import { traceIbcStatus2 } from '@/wallet-utils/ibc/trace-ibc-status'
import { queryKeys } from '@/query-keys'
import { MutationParameters } from './types'

// [sign/broadcast] mutations and [trace] mutation are a 2-part process.
// First, if [sign/broadcast] doesn't succeed within the UI time limit, [trace] mutation will continue
// the [tracing] process so user can continue when the ibc transfer completes if they haven't closed the modal yet.
// We can use the `isLoading` status provided by [trace] mutation to display the "Return Later" screen.
const useTraceIbcTransfer = ({ withdrawStTokenToDexTransaction }: MutationParameters) => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: async (): Promise<{ status: IBCTransferStatus }> => {
      if (!withdrawStTokenToDexTransaction) {
        throw fatal('Unable to trace ibc status while transaction is empty.')
      }

      const status = await traceIbcStatus2({ denom: 'STRD', tx: withdrawStTokenToDexTransaction }, { timeout: false })

      await client.invalidateQueries({
        queryKey: queryKeys.transactionHistoryIbcStatusByHash({ hash: withdrawStTokenToDexTransaction.transactionHash })
      })

      return { status }
    }
  })
}

export { useTraceIbcTransfer }
